const config = {
  contractAddress: "0x20a62c2A93bc425f489F8EFB92E5Fb8F69A035a6", // final contract
};

export default config;


// 0x0a8d11d13d73e46870765584d53F416D7AcD63A7